export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Deposito cauzionale',
    },
    product_type: {
      label: 'Tipo di prodotto',
      options: {
        packaged: 'Confezionato',
        prepared: 'Preparato',
      },
    },
    packaging_material: {
      label: 'Materiale di imballaggio',
    },
    brand_or_manufacturer: {
      label: 'Marca o produttore',
    },
    net_quantity: {
      label: 'Quantità netta',
    },
    base_price: {
      label: 'Imposta prezzo per unità (es. per litro per una bevanda)',
      placeholder: 'Prezzo per unità',
    },
    alcohol_by_volume_percent: {
      label: 'Percentuale alcolica',
    },
    caffeine_mg_per_100ml: {
      label: 'Caffeina (mg per 100ml di prodotto)',
    },
    ingredients_text: {
      label: 'Ingredienti',
    },
    allergens_list: {
      label: 'Allergeni',
    },
    additives_list: {
      label: 'Additivi',
    },
    has_nutrition_table: {
      label: 'Compila la tabella nutrizionale (per 100{{unit}} di prodotto)',
    },
    energy_kj: {
      label: 'Energia (kJ)',
    },
    energy_kcal: {
      label: 'Energia (kcal)',
    },
    fat_g: {
      label: 'Grassi',
    },
    saturates_g: {
      label: 'Grassi saturi',
    },
    carbohydrate_g: {
      label: 'Carboidrati',
    },
    sugars_g: {
      label: 'Zuccheri',
    },
    protein_g: {
      label: 'Proteine',
    },
    salt_g: {
      label: 'Sale',
    },
    identifiers: {
      label: 'Identificatori',
    },
  },
};
